import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3caee643"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex row" }
const _hoisted_2 = { class: "table_wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "모니터링 채팅방 수", -1))
const _hoisted_4 = { class: "board_table" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "텔레그램"),
    /*#__PURE__*/_createElementVNode("th", null, "디스코드"),
    /*#__PURE__*/_createElementVNode("th", null, "카카오톡"),
    /*#__PURE__*/_createElementVNode("th", null, "기타"),
    /*#__PURE__*/_createElementVNode("th", null, "합계")
  ])
], -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { colspan: 10 }
const _hoisted_9 = { class: "board_graph_list" }
const _hoisted_10 = { class: "flex row" }
const _hoisted_11 = { class: "table_wrap" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "모니터링 수(캡쳐 수)", -1))
const _hoisted_13 = { class: "board_table" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "텔레그램"),
    /*#__PURE__*/_createElementVNode("th", null, "디스코드"),
    /*#__PURE__*/_createElementVNode("th", null, "카카오톡"),
    /*#__PURE__*/_createElementVNode("th", null, "기타"),
    /*#__PURE__*/_createElementVNode("th", null, "합계")
  ])
], -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { colspan: 10 }
const _hoisted_18 = { class: "board_graph_list" }
const _hoisted_19 = { class: "flex row" }
const _hoisted_20 = { class: "table_wrap" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "탐지 수", -1))
const _hoisted_22 = { class: "board_table" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "텔레그램"),
    /*#__PURE__*/_createElementVNode("th", null, "디스코드"),
    /*#__PURE__*/_createElementVNode("th", null, "카카오톡"),
    /*#__PURE__*/_createElementVNode("th", null, "기타"),
    /*#__PURE__*/_createElementVNode("th", null, "합계")
  ])
], -1))
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { colspan: 10 }
const _hoisted_27 = { class: "board_graph_list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          (!$setup.props.loading && $setup.chartData.room)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                _createElementVNode("td", null, _toDisplayString($setup.table.room.telegram.toLocaleString()), 1),
                _createElementVNode("td", null, _toDisplayString($setup.table.room.discord.toLocaleString()), 1),
                _createElementVNode("td", null, _toDisplayString($setup.table.room.kakaoTalk.toLocaleString()), 1),
                _createElementVNode("td", null, _toDisplayString($setup.table.room.etc.toLocaleString()), 1),
                _createElementVNode("td", null, _toDisplayString($setup.table.room.total.toLocaleString()), 1)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_8, [
                    _createVNode(_component_Spinner)
                  ])
                ])
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (!$setup.props.loading)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.chartData.room, (data) => {
              return (_openBlock(), _createBlock(_component_Chart, {
                style: {"height":"150px"},
                defaultLayout: $setup.chartLayout,
                data: data
              }, null, 8, ["defaultLayout", "data"]))
            }), 256))
          : (_openBlock(), _createBlock(_component_Spinner, { key: 1 }))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("table", _hoisted_13, [
          _hoisted_14,
          (!$setup.props.loading && $setup.chartData.room)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                _createElementVNode("td", null, _toDisplayString($setup.table.bot.telegram.toLocaleString()), 1),
                _createElementVNode("td", null, _toDisplayString($setup.table.bot.discord.toLocaleString()), 1),
                _createElementVNode("td", null, _toDisplayString($setup.table.bot.kakaoTalk.toLocaleString()), 1),
                _createElementVNode("td", null, _toDisplayString($setup.table.bot.etc.toLocaleString()), 1),
                _createElementVNode("td", null, _toDisplayString($setup.table.bot.total.toLocaleString()), 1)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_17, [
                    _createVNode(_component_Spinner)
                  ])
                ])
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        (!$setup.props.loading)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.chartData.bot, (data) => {
              return (_openBlock(), _createBlock(_component_Chart, {
                style: {"height":"150px"},
                defaultLayout: $setup.chartLayout,
                data: data
              }, null, 8, ["defaultLayout", "data"]))
            }), 256))
          : (_openBlock(), _createBlock(_component_Spinner, { key: 1 }))
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("table", _hoisted_22, [
          _hoisted_23,
          (!$setup.props.loading && $setup.chartData.room)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_24, [
                _createElementVNode("td", null, _toDisplayString($setup.table.detect.telegram.toLocaleString()), 1),
                _createElementVNode("td", null, _toDisplayString($setup.table.detect.discord.toLocaleString()), 1),
                _createElementVNode("td", null, _toDisplayString($setup.table.detect.kakaoTalk.toLocaleString()), 1),
                _createElementVNode("td", null, _toDisplayString($setup.table.detect.etc.toLocaleString()), 1),
                _createElementVNode("td", null, _toDisplayString($setup.table.detect.total.toLocaleString()), 1)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_25, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_26, [
                    _createVNode(_component_Spinner)
                  ])
                ])
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        (!$setup.props.loading)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.chartData.detect, (data) => {
              return (_openBlock(), _createBlock(_component_Chart, {
                style: {"height":"150px"},
                defaultLayout: $setup.chartLayout,
                data: data
              }, null, 8, ["defaultLayout", "data"]))
            }), 256))
          : (_openBlock(), _createBlock(_component_Spinner, { key: 1 }))
      ])
    ])
  ], 64))
}